import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "button-link-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_app_tooltip = _resolveComponent("app-tooltip")!

  return (_ctx.tooltipText)
    ? (_openBlock(), _createBlock(_component_app_tooltip, {
        key: 0,
        text: _ctx.tooltipText,
        "max-width": _ctx.tooltipWidth
      }, {
        activator: _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass(["button-link", { 'with-icon': _ctx.hasIcon }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
          }, [
            (_ctx.iconName)
              ? (_openBlock(), _createBlock(_component_AppIcon, {
                  key: 0,
                  name: _ctx.iconName,
                  width: "18px",
                  class: "button-link-icon"
                }, null, 8, ["name"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1)
          ], 2)
        ]),
        _: 1
      }, 8, ["text", "max-width"]))
    : _createCommentVNode("", true)
}